define("shared/components/shared/mobile/drawer/carousel-card", ["exports", "@ember/component", "@glimmer/component", "shared/utils/platform-check", "@ember/template-factory"], function (_exports, _component, _component2, _platformCheck, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"shared/utils/platform-check",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <figure class="u--m__b__md" data-test-id="mobile-drawer-carousel-card">
    <Shared::Carousel
      @carouselMediaItems={{@cards}}
      @class="cCP--feature__slide"
      @index={{@index}}
      @updateIndex={{@updateIndex}}
      as |carousel|
    >
      <carousel.inner
        data-test-id="mobile-drawer-carousel-inner"
        {{(modifier "touch-gesture" onTouchStart=this.onTouchStart onTouchEnd=this.onTouchEnd)}}
        as |card idx|
      >
        <div data-test-id={{concat "carousel-inner-media-" idx}}>
          <Shared::Image @class="o--media u--m__t__md u--m__b" @picture={{card}} />
          <p class="u--text--md">{{card.alt}}</p>
        </div>
        {{#if card.needsUpgrade}}
          <div class="u--m__b">
            <Shared::Button::Upgrade
              @additional="block"
              @feature={{card.featureUpgradeName}}
              @location="scheduling_modal_hashtag_suggestion_card"
              @seamlessCheckoutSuccessCallback={{@seamlessCheckoutSuccessCallback}}
              @size="large"
              @variant="proceed"
            />
          </div>
        {{/if}}
      </carousel.inner>
      <carousel.indicators />
      <carousel.controls />
    </Shared::Carousel>
  </figure>
  */
  {
    "id": "cvgnU798",
    "block": "[[[10,\"figure\"],[14,0,\"u--m__b__md\"],[14,\"data-test-id\",\"mobile-drawer-carousel-card\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@carouselMediaItems\",\"@class\",\"@index\",\"@updateIndex\"],[[30,1],\"cCP--feature__slide\",[30,2],[30,3]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,4,[\"inner\"]],[[24,\"data-test-id\",\"mobile-drawer-carousel-inner\"],[4,[50,[28,[37,2],[\"modifier:touch-gesture\"],null],2,null,[[\"onTouchStart\",\"onTouchEnd\"],[[30,0,[\"onTouchStart\"]],[30,0,[\"onTouchEnd\"]]]]],null,null]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[15,\"data-test-id\",[28,[37,3],[\"carousel-inner-media-\",[30,6]],null]],[12],[1,\"\\n        \"],[8,[39,4],null,[[\"@class\",\"@picture\"],[\"o--media u--m__t__md u--m__b\",[30,5]]],null],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md\"],[12],[1,[30,5,[\"alt\"]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,5,[\"needsUpgrade\"]],[[[1,\"        \"],[10,0],[14,0,\"u--m__b\"],[12],[1,\"\\n          \"],[8,[39,6],null,[[\"@additional\",\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@size\",\"@variant\"],[\"block\",[30,5,[\"featureUpgradeName\"]],\"scheduling_modal_hashtag_suggestion_card\",[30,7],\"large\",\"proceed\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[5,6]]]]],[1,\"\\n    \"],[8,[30,4,[\"indicators\"]],null,null,null],[1,\"\\n    \"],[8,[30,4,[\"controls\"]],null,null,null],[1,\"\\n  \"]],[4]]]]],[1,\"\\n\"],[13]],[\"@cards\",\"@index\",\"@updateIndex\",\"carousel\",\"card\",\"idx\",\"@seamlessCheckoutSuccessCallback\"],false,[\"shared/carousel\",\"modifier\",\"-resolve\",\"concat\",\"shared/image\",\"if\",\"shared/button/upgrade\"]]",
    "moduleName": "shared/components/shared/mobile/drawer/carousel-card.hbs",
    "isStrictMode": false
  });
  class CarouselCardComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _defineProperty(this, "touchStartPosition", 0);
      _defineProperty(this, "onTouchStart", event => {
        event.stopPropagation();
        this.touchStartPosition = this.getScreenX(event);
      });
      _defineProperty(this, "onTouchEnd", event => {
        event.stopPropagation();
        const isRightSwipe = this.getScreenX(event) > this.touchStartPosition;
        const isLeftSwipe = this.getScreenX(event) < this.touchStartPosition;
        if (isRightSwipe) {
          if (this.args.index > 0) {
            this.args.updateIndex(this.args.index - 1);
          }
        } else if (isLeftSwipe) {
          if (this.args.index < this.args.cards.length - 1) {
            this.args.updateIndex(this.args.index + 1);
          }
        }
      });
      this.args.triggerTrackWithInitialIndex();
    }
    get isIos() {
      return (0, _platformCheck.isIos)(navigator);
    }
    getScreenX(event) {
      return event.changedTouches[0].screenX;
    }
  }
  _exports.default = CarouselCardComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CarouselCardComponent);
});